module.exports = __webpack_public_path__ + "static/img/train.69268eb6.svg";